import styled from 'styled-components';
import { Button, TableRow, TextField } from '@mui/material';

export const cellSx = {
  fontFamily: 'Open Sans',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.89%',
  verticalAlign: 'middle',
  borderBottom: '0.5px solid var(--ahg-gray-lighten4, #E7E7EB)',
  color: 'var(--ahg-gray-darken1, #5A6268)',
  padding: '10px 16px',
};

export const headerCellSx = {
  fontFamily: 'Open Sans',
  fontSize: '14px',
  lineHeight: '14px',
  fontWeight: 600,
  letterSpacing: '0.89%',
  color: 'rgba(0, 0, 0, 0.87)',
  backgroundColor: '#FFFFFF',
  borderBottom: '0.5px solid var(--ahg-gray-lighten4, #E7E7EB)',
  padding: '12px 16px',
};

export const StyledTableRow = styled(TableRow)`
  &:nth-of-type(odd) {
    background-color: #FFFFFF;
  }

  &:nth-of-type(even) {
    background-color: var(--ahg-waterloo-lighten5, #F0F1F5);
  }
`;

export const SearchTextField = styled(TextField)`
  && {
    flex: 1;

    .MuiInputBase-input {
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      line-height: 24px;
      padding: 6px 0 4px;
    }

    .MuiInputBase-input::placeholder {
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      color: var(--ahg-waterloo-base, #78788F);
      opacity: 1;
    }

    .MuiInput-underline:before {
      border-bottom: 1px solid var(--ahg-gray-lighten4, #E7E7EB);
    }

    .MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom: 1px solid var(--ahg-waterloo-base, #78788F);
    }

    .MuiInput-underline:after {
      border-bottom: 2px solid var(--ahg-primary-base, #1199DD);
    }
  }
`;

export const DownloadButton = styled(Button)`
  && {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    text-transform: none;
    color: var(--ahg-waterloo-darken1, #58586B);
    min-width: auto;
    padding: 8px 12px;

    .MuiButton-startIcon {
      color: var(--ahg-waterloo-darken1, #58586B);
    }

    &:hover {
      background-color: transparent;
      color: var(--ahg-waterloo-darken1, #58586B);
    }
  }
`;

export const CloseFooterButton = styled(Button)`
  && {
    width: 100%;
    height: 42px;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    text-transform: none;
    border-radius: 4px;
  }
`;
